import {
    ContentClassificationView,
    ContentMediaView,
    ContentTypeView,
    Maybe,
    useRefreshContentMediaMutation
} from '../../../api/client'
import { useState } from 'react'

const FACEBOOK_COMMENT_TYPES: ContentTypeView[] = [
    ContentTypeView.FacebookPagePostComment,
    ContentTypeView.FacebookAdComment
]

type Props = {
    media: ContentMediaView[]
    contentId: number
    contentType: ContentTypeView
}

const MINIMUM_SIGNIFICANT_CLASSIFICATION = 0.5

export default function ImageAbuseSummary(props: Props) {
    const { media, contentId, contentType } = props

    const [refreshedMedia, setRefreshedMedia] = useState<ContentMediaView[] | null>(null)
    const [hasAttemptedRefresh, setHasAttemptedRefresh] = useState(false)
    const [refreshContentMedia] = useRefreshContentMediaMutation()

    const displayMedia = refreshedMedia || media

    if (!!!media) {
        return <></>
    }

    async function handleImageError() {
        if (hasAttemptedRefresh) return
        setHasAttemptedRefresh(true)
        if (!FACEBOOK_COMMENT_TYPES.includes(contentType)) return
        try {
            const result = await refreshContentMedia({
                variables: { contentId }
            })
            if (result.data?.refreshContentMedia) {
                setRefreshedMedia(result.data.refreshContentMedia)
            }
        } catch {
            // Refresh failed — image will remain broken
        }
    }

    function isClassificationSignificant(classification: Maybe<ContentClassificationView>) {
        return (
            classification?.classification &&
            classification?.classification > MINIMUM_SIGNIFICANT_CLASSIFICATION
        )
    }

    /**
     * Converst the classifer name from ImageXXXXX to a display name by remmoving the Image prefix.
     * @param classifierName The image classifier name from the database in the form of ImageXXXXXX
     */
    function convertClassifierName(classifierName?: string) {
        return classifierName && classifierName.replace('Image', '')
    }

    function convertScoreToDisplayPercentage(percentage: number | undefined | null) {
        return percentage && Math.round(percentage * 100)
    }

    return (
        <div className="flex flex-row">
            {displayMedia?.map((media, index) => {
                const imageUrl = media.presignedUrl ?? media.publicUrl
                if (imageUrl) {
                    let significationClassifications = media.mediaClassifications?.filter(
                        isClassificationSignificant
                    )
                    return (
                        <div className="pr-1 contents" key={media.serviceMediaId}>
                            <a
                                href={imageUrl}
                                className="text-arwen-700 underline mr-2"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={imageUrl}
                                    className="max-h-36 max-w-36"
                                    alt="Loading..."
                                    onError={handleImageError}
                                />
                            </a>

                            <div className="relative -mt-6 flex flex-col bg-black bg-opacity-90 text-white">
                                {significationClassifications
                                    ?.sort((a, b) =>
                                        a && b && a.classification && b.classification
                                            ? b?.classification - a?.classification
                                            : 0
                                    )
                                    .map((classification) => {
                                        return (
                                            <span key={classification?.classifierName}>
                                                {' '}
                                                {convertClassifierName(
                                                    classification?.classifierName
                                                )}{' '}
                                                {convertScoreToDisplayPercentage(
                                                    classification?.classification
                                                )}
                                                %
                                            </span>
                                        )
                                    })}
                            </div>
                        </div>
                    )
                }

                return <></>
            })}
        </div>
    )
}
